import { getItemFromLocalStorage } from "@/App/services/LocalStorage";
import { AuthorizationService } from "@/Login/services";
import { removeUndefinedFields } from "@/Utils/objectUtils";
import * as protocolService from "../protocol.service";
import { QuestionParams } from "../types/QuestionParams";
import { state } from "./protocol-store";

export const prepareQuestionParams = (
  question?: string,
  responseType: "detailed" | "summary" = "summary",
  questionUuid?: string,
) => {
  const user = AuthorizationService.getUser();
  const selectedTeam = getItemFromLocalStorage({
    key: "selectedTeam",
    parse: true,
  });

  const organization = {
    id: selectedTeam?.id || "",
    type: "emsAgency",
  };
  if (!organization) return {};

  const params: Record<string, unknown> = {
    question: question || "",
    responseType,
    questionUuid,
    organization,
    emtLevel: protocolService.getEmtLevel(user),
  };

  if (state.chatSessionID) {
    params.chatSessionID = state.chatSessionID;
  }

  if (state.currentCaseId) {
    params.twiageCaseId = state.currentCaseId;
  }
  return removeUndefinedFields<QuestionParams>(params);
};
